define('viewModels/privileged/qm/QualitySummaryView',[
    'lib/knockout',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/EvaluationSummaryView',
    'viewModels/privileged/qm/SurveySummaryView',
    'services/qm/qualityAuth',
    'services/featureToggleService'
], function (
    ko,
    ViewModel,
    EvaluationSummaryView,
    SurveySummaryView,
    qualityAuth
    ) {
    'use strict';

    var QualitySummaryView = ViewModel.extend(function (conversationId, hasParticipantToEvaluate, deleteEvaluationCallback) {
        var self = this;

        self.evaluationSummaryView = ko.observable();
        if (qualityAuth.canAddEvaluation() ||
            qualityAuth.canDeleteEvaluation() ||
            qualityAuth.canAddCalibration()) {
            self.evaluationSummaryView(self.subView(EvaluationSummaryView, conversationId, hasParticipantToEvaluate, deleteEvaluationCallback));
        }

        self.surveySummaryView = ko.observable();
        if (qualityAuth.canViewSurvey()) {
            self.surveySummaryView(self.subView(SurveySummaryView, conversationId));
        }
    });

    return QualitySummaryView;
});

